import {
  Toast,
  Dialog
} from 'vant'

export const showToast = str => {
  Toast({
    position: 'bottom',
    message: str
  })
}

showToast.success = msg => {
  Toast.success(msg)
}

export const showLoading = str => {
  Toast.loading({
    message: str || '加载中...',
    duration: 0,
    forbidClick: true
  })
}

export const hideLoading = () => {
  Toast.clear()
}

export const showAlert = params => {
  return Dialog.alert(Object.assign({
    message: '弹窗内容'
  }, typeof params === 'string' ? {
    message: params
  } : params))
}

/**
 * 验证手机号有效性
 * @param tel
 * @returns {boolean}
 */
export const checkTel = (tel) => {
  let reg = /^(1[0-9]{10})$/
  return reg.test(tel)
}

/**
 * 验证邮箱有效性
 * @param mail
 * @returns {boolean}
 */
export const checkMail = (mail) => {
  //var reyx = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
  var reyx = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
  return !(mail === "" || reyx.test(mail) === false);
}

export const getQueryString = (name)=> {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  let r = decodeURI(window.location.search.substr(1)).match(reg);
  if (r != null)return unescape(r[2]);
  return null;
}

//判断是否安卓手机
export const isAndroid = () => {
  let u = navigator.userAgent;
  return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
}
